import React, { useState } from 'react';
import { Collapse, IconButton, List, ListItem, ListItemText, Popover } from '@material-ui/core';
import { Settings as SettingsIcon, ExpandLess, ExpandMore } from '@material-ui/icons';
import { Check } from '@material-ui/icons';

// Define props type
type SettingsProps = {
    playbackSpeed: number;
    setPlaybackSpeed: (value: number) => void;
};

const SettingsButton: React.FC<SettingsProps> = ({ playbackSpeed, setPlaybackSpeed }) => {
    // Define state variables
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null); // Element that triggered the popover
    const [openSpeedSettings, setOpenSpeedSettings] = useState(false); // Whether playback speed settings are open

    // Handler for opening the popover
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget) ;
    };
    // Handler for closing the popover
    const handleClose = () => {
        setAnchorEl(null);
    };

    // Handler for toggling the playback speed settings
    const handleSpeedSettingsClick = () => {
        setOpenSpeedSettings(!openSpeedSettings);
    };

    // Define open state and id for popover
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    // Handler for changing playback speed and closing the popover
    const handlePlaybackSpeedChange = (speed: number) => {
        setPlaybackSpeed(speed);
        handleClose();
    };

    // Render the settings button and popover
    return (
        <div>
            <IconButton color="inherit" onClick={handleClick}>
                <SettingsIcon />
            </IconButton>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <List component="nav" aria-label="settings">
                    <ListItem button onClick={handleSpeedSettingsClick}>
                        <ListItemText primary="Playback speed" />
                        {openSpeedSettings ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>

                    <Collapse in={openSpeedSettings} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {[1, 2, 3, 5, 10, 30, 60].map((speed) => (
                                <ListItem button key={speed} onClick={() => handlePlaybackSpeedChange(speed)}>
                                    <ListItemText primary={`${speed}x`} />
                                    {playbackSpeed === speed && <Check />}
                                </ListItem>
                            ))}
                        </List>
                    </Collapse>
                </List>
            </Popover>
        </div>
    );
};

export default SettingsButton;
